import { useCallback, useState } from 'react'
import { ProductVariantCombinationsPrepared } from '../../types'
import { CreateCustomVariantsStep1 } from './Steps/FirstStep'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import { CreateVariantsSecondsStep } from '../CreateVariantsSecondStep'

interface CreateCustomVariantsProps extends CreateCustomVariantsLogicProps { }

const CreateCustomVariants: React.FC<CreateCustomVariantsProps> = ({ ...rest }) => {
    const { Component, combinations, onSubmitInner } = useCreateCustomVariantsLogic(rest)
    return (
        <Component onSubmit={onSubmitInner} combinations={combinations || []} />
    )
}

const ComponentsByStep = {
    1: CreateCustomVariantsStep1,
    2: CreateVariantsSecondsStep
}

interface CreateCustomVariantsLogicProps extends ModalEditComponentProps { }

const useCreateCustomVariantsLogic = ({ setOpened, onSubmit }: CreateCustomVariantsLogicProps) => {
    const [combinations, setCombinations] = useState<ProductVariantCombinationsPrepared | null>(null)
    const [step, setStep] = useState<1 | 2>(1)

    const step1Submit: OnSubmit = useCallback(async (res: any) => {
        const response = await res.json()
        if (response) {
            setCombinations(response)
            setStep(2)
        }
    }, [])
    const step2Submit: OnSubmit = useCallback((res: any, values: any) => {
        onSubmit(res, values)
        setOpened(null)
    }, [onSubmit, setOpened])
    const onSubmitInner: OnSubmit = useCallback((res: any, values: any) => {
        const submits = {
            1: step1Submit,
            2: step2Submit
        }
        submits[step](res, values)
    }, [step, step1Submit, step2Submit])

    const Component = ComponentsByStep[step]
    return { Component, setStep, combinations, setCombinations, onSubmitInner }
}

export default CreateCustomVariants